export default "__VITE_ASSET__EDi2qW_2__"